<template>
  <div class="py-12" ref="certificate">
    <div class="flex">
      <div class="w-1/4">
        <img src="@/assets/images/certlogo.png" class="w-full h-full" />
      </div>
      <div class="text-center w-3/4 px-4">
        <div class="flex justify-center mt-3">
          <img src="@/assets/images/clogo.png" class="h-20 lg:h-auto" />
        </div>
        <div class="">
          <p
            class="
              mt-4
              font-semibold
              text-lightb
              lg:text-xl
              md:text-base
              text-sm
            "
          >
            CERTIFICATE OF COMPLETION
          </p>
          <p
            class="mt-4 font-medium text-black lg:text-xl md:text-base text-sm"
          >
            This is awarded to
          </p>
          <p
            class="
              my-6
              font-bold
              lg:text-xl
              md:text-base
              text-sm text-black
              uppercase
            "
          >
            CAREGIVER
          </p>
          <p
            class="
              mt-4
              font-medium
              lg:text-xl
              md:text-base
              text-sm text-black
              mx-auto
            "
          >
            For completing the Emotional first aid- Helpline for respondent
            training organized by Caregiver Saathi.
          </p>
        </div>

        <div class="flex justify-end mr-4 mt-6">
          <div class="lg:w-2/4 w-2/5">
            <img
              src="@/assets/images/bhavana sign.png"
              class="w-full object-cover h-20"
            />
            <p class="pt-2 mt-2 font-semibold text-sm text-center borderblueb">
              Bhavana Issar <br />
              Caregiver Saathi
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../scss/index.scss";
export default {};
</script>
